import { render } from "./BlockCounter.vue?vue&type=template&id=4f4b42fa&scoped=true"
import script from "./BlockCounter.vue?vue&type=script&lang=js"
export * from "./BlockCounter.vue?vue&type=script&lang=js"

import "./BlockCounter.vue?vue&type=style&index=0&id=4f4b42fa&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4b42fa"]])

export default __exports__